/* global document, setTimeout, window, navigator */

import escapeToClose from './escape-to-close';

export default function(rootElement, contentLocation) {
  const showModal = () => {
    const scrollPosition = window.pageYOffset;

    document.body.classList.add('body--freeze');
    document.body.style.top = `-${scrollPosition}px`;
    document.documentElement.classList.add('html--instant-scroll');

    rootElement.setAttribute('aria-hidden', 'false');

    setTimeout(() => {
      rootElement.removeAttribute('fading');
    }, 10);
  };

  const insertContent = () => {
    const content = contentLocation.innerHTML;
    const contentArea = rootElement.querySelector('[data-role="modal-content-area"]');

    contentArea.innerHTML = content;
  };

  const userAgentCheck = (userAgent, checkString) => userAgent && userAgent.toLowerCase().includes(checkString);

  const modalMessage = rootElement.querySelector('[data-role="modal-message"]');
  const modalBacking = rootElement.querySelector('[data-role="modal-backing"]');
  const contentArea = rootElement.querySelector('[data-role="modal-content-area"]');
  const isSafari = userAgentCheck(navigator && navigator.userAgent, 'safari');
  const isIphone = userAgentCheck(navigator && navigator.userAgent, 'iphone');
  const isChrome = userAgentCheck(navigator && navigator.userAgent, 'chrome');
  const isAndroid = userAgentCheck(navigator && navigator.userAgent, 'android');
  const isCrios = userAgentCheck(navigator && navigator.userAgent, 'crios');

  if (modalMessage && contentArea && isSafari && isIphone && !isChrome && !isCrios && !isAndroid) {
    modalMessage.classList.add('sdc-site-modal__message-safari');
    modalBacking.classList.add('sdc-site-modal__backing-safari');
    contentArea.classList.add('sdc-site-modal__message-content-safari');
  }

  insertContent();
  showModal();

  rootElement.escapeToClose = escapeToClose.bind(rootElement);

  window.addEventListener('keyup', rootElement.escapeToClose, false);
}
